import React from "react";
import Header from "./common/Header";
import Footer from "./common/Footer";

const GuestPageWrapper = ({ children }) => {
    return (
        <>
            <Header />
            { children }
            <Footer />
        </>
    );
};

export default GuestPageWrapper;
